import React from "react";
import { useSelector } from "react-redux";
import { Crown, BadgeCheck } from "lucide-react";
import { motion } from "framer-motion";
import { fadeUp } from "animations/variants";
import { WhyChooseUsText } from "i18n/about";

const WhyChooseUs = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = WhyChooseUsText[lang];

  return (
    <section className="py-20 bg-[#f7f3ef]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-[Crimson] text-4xl md:text-5xl text-reddark">
            {t.title}
          </h2>

          <div className="w-24 h-[2px] bg-reddark mx-auto mt-6 mb-8" />
        </motion.div>

        {/* Reasons */}
        <div className="max-w-6xl mx-auto">
          <div className="space-y-8">
            {t.reasons.map((item, index) => (
              <motion.div
                key={index}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="flex items-start gap-4"
              >
                <BadgeCheck
                  size={20}
                  strokeWidth={2}
                  className="text-reddark mt-1 shrink-0"
                />

                <p className="text-lg leading-8 text-gray-800">
                  <span className="font-semibold text-[#243B5A]">
                    {item.title}:
                  </span>{" "}
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Closing */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="mt-14 border-l-4 border-reddark pl-6 italic text-gray-700 text-lg leading-8"
          >
            {t.closing}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
